import { render, staticRenderFns } from "./UpdateTracking.vue?vue&type=template&id=66d4bbeb&lang=pug&"
import script from "./UpdateTracking.vue?vue&type=script&lang=ts&"
export * from "./UpdateTracking.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateTracking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports